import React, { useState, useEffect, useRef } from "react";
import './product_sstyle.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import 'aos/dist/aos.css';
import banner from '../img/logo/banner-bg.png';
import amogh from '../img/logo/amogh.png'
import top from '../img/logo/left_top.png';
import bottom from '../img/logo/left_bottom.png';
import right_top from '../img/logo/right_top.png';
import right_bottom from '../img/logo/right_bottom.png';
import 'bootstrap/dist/css/bootstrap.min.css';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { FiMail, FiPhone } from "react-icons/fi";
import 'react-medium-image-zoom/dist/styles.css';
import intro from "../img/products/speaklear_intro.gif";
import video_intro from "../img/products/video_intro.mp4";
import impo from "../img/products/impo.svg";
import usericon from "../img/products/user.svg";
import mobileicon from "../img/products/mobile.svg";
import emailicon from "../img/products/email.svg";
import Footer from "./Footer";

function Privacypolicy() {
  return (
<>
<section className="privacy_policy"> 
<div style={{ padding: '2rem', maxWidth: '900px', margin: '6% auto', fontFamily: 'Arial, sans-serif',  }}>
      <h1>PRIVACY POLICY</h1>
      <p><b>Last updated: April 04, 2025</b></p>
<p>
This Privacy Notice for <b>Ablepro Solutions Pvt. Ltd.</b> (‘we’, ‘us’, or ‘our’), describes how and why we might access, collect, store, use, and/or share (‘process’) your personal information when you use our services (‘Services’), including when you:
</p>

<ul>
  <li>Download and use our mobile application (Spea<span className="para-text-livvic">klear™</span>), or any other application of ours that links to this Privacy Notice.</li>
  <li>Engage with us in other related ways, including any sales, marketing, or events.</li>
</ul>

<p>
  <strong>Questions or concerns?</strong> Reading this Privacy Notice will help you understand your privacy rights and choices. We are responsible for making decisions about how your personal information is processed. If you do not agree with our policies and practices, please do not use our Services. If you still have any questions or concerns, please contact us at <a href="mailto:support@ableproindia.com">support@ableproindia.com</a>.
</p>

<h3 className="mt-4">SUMMARY OF KEY POINTS</h3>

<p><i>
  This summary provides key points from our Privacy Notice, but you can find out more details about any of these topics by using our table of contents below to find the section you are looking for.</i>
</p>

<ul>
  <li><strong>What personal information do we process?</strong> When you visit, use, or navigate our Services, we may process personal information depending on how you interact with us and the Services, the choices you make, and the products and features you use. <a href="#personal-information-disclosure">Learn more about personal information you disclose to us.</a></li>
  
  <li><strong>Do we process any sensitive personal information?</strong> Some of the information may be considered 'special' or 'sensitive' in certain jurisdictions, for example, your racial or ethnic origins, sexual orientation, and religious beliefs. We may process sensitive personal information when necessary with your consent or as otherwise permitted by applicable law. <a href="#personal-information-disclosure">Learn more about sensitive information we process.</a></li>
  
  <li><strong>Do we collect any information from third parties?</strong> We may collect information from public databases, marketing partners, social media platforms, and other outside sources. <a href="#personal-information-disclosure">Learn more about information collected from other sources.</a></li>
  
  <li><strong>How do we process your information?</strong> We process your information to provide, improve, and administer our Services, communicate with you, for security and fraud prevention, and to comply with law. We may also process your information for other purposes with your consent. We process your information only when we have a valid legal reason to do so. <a href="#how-we-process-information">Learn more about how we process your information.</a></li>
  
  <li><strong>In what situations and with which parties do we share personal information?</strong> We may share information in specific situations and with specific third parties. <a href="#share-personal-information">Learn more about when and with whom we share your personal information.</a></li>
  
  <li><strong>How do we keep your information safe?</strong> We have adequate organisational and technical processes and procedures in place to protect your personal information. However, no electronic transmission over the internet or information storage technology can be guaranteed to be 100% secure, so we cannot promise or guarantee that hackers, cybercriminals, or other unauthorised third parties will not be able to defeat our security and improperly collect, access, steal, or modify your information. <a href="#your-rights">Learn more about how we keep your information safe.</a></li>
  
  <li><strong>What are your rights?</strong> Depending on where you are located geographically, the applicable privacy law may mean you have certain rights regarding your personal information. <a href="#your-rights">Learn more about your privacy rights.</a></li>
  
  <li><strong>How do you exercise your rights?</strong> The easiest way to exercise your rights is by contacting us. We will consider and act upon any request in accordance with applicable data protection laws.</li>
</ul>

<p>
  Want to learn more about what we do with any information we collect? <a href="#table-of-content">Review the Privacy Notice in full.</a>
</p>


      <h2 class="pt-5" id="table-of-content">Table of Contents</h2>
      <ol>
        <li><a class="tclass" href="#personal-information-disclosure">What Information Do We Collect?</a></li>
        <li><a class="tclass" href="#how-we-process-information">How Do We Process Your Information?</a></li>
        <li><a class="tclass" href="#share-personal-information">When and With Whom Do We Share Your Personal Information?</a></li>
        <li><a class="tclass" href="#cookies-tracking">Do We Use Cookies and Other Tracking Technologies?</a></li>
        <li><a class="tclass" href="#ai-based-products">Do We Offer Artificial Intelligence-Based Products?</a></li>
        <li><a class="tclass" href="#how-long-we-keep">How Long Do We Keep Your Information?</a></li>
        <li><a class="tclass" href="#keep-information-safe">How Do We Keep Your Information Safe?</a></li>
        <li><a class="tclass" href="#your-rights">What Are Your Privacy Rights?</a></li>
        <li><a class="tclass" href="#do-not-track">Controls for Do-Not-Track Features</a></li>
        <li><a class="tclass" href="#notice-update">Do We Make Updates to This Notice?</a></li>
        <li><a class="tclass" href="#contact-about-notice">How Can You Contact Us About This Notice?</a></li>
        <li><a class="tclass" href="#contact-about-notice">How Can You Review, Update, or Delete the Data We Collect From You?</a></li>
      </ol>

      <h2 id="personal-information-disclosure" class="pt-5">1. WHAT INFORMATION DO WE COLLECT?</h2>

        <h5>Personal information you disclose to us</h5>
        <p><strong>In Short:</strong> We collect personal information that you provide to us.</p>

        <p>
          We collect personal information that you voluntarily provide to us when you register on the Services, express an interest in obtaining information about us or our products and Services, when you participate in activities on the Services, or otherwise when you contact us.
        </p>

        <p><strong>Personal Information Provided by You.</strong> The personal information that we collect depends on the context of your interactions with us and the Services, the choices you make, and the products and features you use. The personal information we collect may include the following:</p>
        <ul>
          <li>names</li>
          <li>phone numbers</li>
          <li>email addresses</li>
          <li>disability information</li>
          <li>contact or authentication data</li>
          <li>billing addresses</li>
          <li>passwords</li>
          <li>usernames</li>
        </ul>

        <p><strong>Sensitive Information.</strong> When necessary, with your consent or as otherwise permitted by applicable law, we process the following categories of sensitive information:</p>
        <ul>
          <li>Health data</li>
        </ul>

        <p><strong>Application Data.</strong> If you use our application(s), we also may collect the following information if you choose to provide us with access or permission:</p>

        <p><strong>Mobile Device Access.</strong> We may request access or permission to certain features from your mobile device, including your mobile device's bluetooth, camera, microphone, storage, and other features. If you wish to change our access or permissions, you may do so in your device's settings.</p>

        <p><strong>Mobile Device Data.</strong> We automatically collect device information (such as your mobile device ID, model, and manufacturer), operating system, version information and system configuration information, device and application identification numbers, browser type and version, hardware model, Internet service provider and/or mobile carrier, and Internet Protocol (IP) address (or proxy server). If you are using our application(s), we may also collect information about the phone network associated with your mobile device, your mobile device's operating system or platform, the type of mobile device you use, your mobile device's unique device ID, and information about the features of our application(s) you accessed.</p>

        <p><strong>Push Notifications.</strong> We may request to send you push notifications regarding your account or certain features of the application(s). If you wish to opt out from receiving these types of communications, you may turn them off in your device's settings.</p>

        <p>
          This information is primarily needed to maintain the security and operation of our application(s), for troubleshooting, and for our internal analytics and reporting purposes.
        </p>

        <p>
          All personal information that you provide to us must be true, complete, and accurate, and you must notify us of any changes to such personal information.
        </p>

        <h5>Information automatically collected</h5>
        <p><strong>In Short:</strong> Some information – such as your Internet Protocol (IP) address and/or browser and device characteristics – is collected automatically when you visit our Services.</p>

        <p>
          We automatically collect certain information when you visit, use, or navigate the Services. This information does not reveal your specific identity (like your name or contact information) but may include device and usage information, such as your IP address, browser and device characteristics, operating system, language preferences, referring URLs, device name, country, location, information about how and when you use our Services, and other technical information. This information is primarily needed to maintain the security and operation of our Services, and for our internal analytics and reporting purposes.
        </p>

        <p>The information we collect includes:</p>
        <ul>
          <li>
            <strong>Log and Usage Data.</strong> Log and usage data is service-related, diagnostic, usage, and performance information our servers automatically collect when you access or use our Services and which we record in log files. Depending on how you interact with us, this log data may include your IP address, device information, browser type, and settings and information about your activity in the Services (such as the date/time stamps associated with your usage, pages and files viewed, searches, and other actions you take such as which features you use), device event information (such as system activity, error reports (sometimes called 'crash dumps'), and hardware settings).
          </li>
          <li>
            <strong>Device Data.</strong> We collect device data such as information about your computer, phone, tablet, or other device you use to access the Services. Depending on the device used, this device data may include information such as your IP address (or proxy server), device and application identification numbers, location, browser type, hardware model, Internet service provider and/or mobile carrier, operating system, and system configuration information.
          </li>
        </ul>

        <h5>Google API</h5>
        <p>Our use of information received from Google API’s will adhere to Google API Services User Data Policy, including the Limited Use requirements.</p>

        <h5>Information collected from other sources</h5>
        <p><strong>In Short:</strong> We may collect limited data from public databases, marketing partners, and other outside sources.</p>

        <p>
          In order to enhance our ability to provide relevant marketing, offers, and services to you and update our records, we may obtain information about you from other sources, such as public databases, joint marketing partners, affiliate programs, data providers, and from other third parties. This information includes mailing addresses, job titles, email addresses, phone numbers, intent data (or user behaviour data), Internet Protocol (IP) addresses, social media profiles, social media URLs, and custom profiles, for purposes of targeted advertising and event promotion.
        </p>






        <h2 className="mt-5 pt-5" id="how-we-process-information">2. HOW DO WE PROCESS YOUR INFORMATION?</h2>

<p><strong>In Short:</strong> We process your information to provide, improve, and administer our Services, communicate with you, for security and fraud prevention, and to comply with law. We may also process your information for other purposes with your consent.</p>

<p>We process your personal information for a variety of reasons, depending on how you interact with our Services, including:</p>

<ul>
  <li>
    <strong>To facilitate account creation and authentication and otherwise manage user accounts.</strong> We may process your information so you can create and log in to your account, as well as keep your account in working order.
  </li>
  <li>
    <strong>To respond to user inquiries/offer support to users.</strong> We may process your information to respond to your inquiries and solve any potential issues you might have with the requested service.
  </li>
  <li>
    <strong>To enable user-to-user communications.</strong> We may process your information if you choose to use any of our offerings that allow for communication with another user.
  </li>
  <li>
    <strong>To request feedback.</strong> We may process your information when necessary to request feedback and to contact you about your use of our Services.
  </li>
  <li>
    <strong>To evaluate and improve our Services, products, marketing, and your experience.</strong> We may process your information when we believe it is necessary to identify usage trends, determine the effectiveness of our promotional campaigns, and to evaluate and improve our Services, products, marketing, and your experience.
  </li>
  <li>
    <strong>To identify usage trends.</strong> We may process information about how you use our Services to better understand how they are being used so we can improve them.
  </li>
</ul>




<h2 className="mt-5 pt-5" id="share-personal-information">3. WHEN AND WITH WHOM DO WE SHARE YOUR PERSONAL INFORMATION?</h2>

<p><strong>In Short:</strong> We may share information in specific situations described in this section and/or with the following third parties.</p>

<p>We may need to share your personal information in the following situations:</p>

<ul>
  <li>
    <strong>Business Transfers.</strong> We may share or transfer your information in connection with, or during negotiations of, any merger, sale of company assets, financing, or acquisition of all or a portion of our business to another company.
  </li>
  <li>
    <strong>Affiliates.</strong> We may share your information with our affiliates, in which case we will require those affiliates to honour this Privacy Notice. Affiliates include our parent company and any subsidiaries, joint venture partners, or other companies that we control or that are under common control with us.
  </li>
  <li>
    <strong>Business Partners.</strong> We may share your information with our business partners to offer you certain products, services, or promotions.
  </li>
</ul>




<h2 className="mt-5 pt-5" id="cookies-tracking">4. DO WE USE COOKIES AND OTHER TRACKING TECHNOLOGIES?</h2>

<p><strong>In Short:</strong> We may use cookies and other tracking technologies to collect and store your information.</p>

<p>
  We may use cookies and similar tracking technologies (like web beacons and pixels) to gather information when you interact with our Services. 
  Some online tracking technologies help us maintain the security of our Services and your account, prevent crashes, fix bugs, save your preferences, 
  and assist with basic site functions.
</p>

<p>
  We also permit third parties and service providers to use online tracking technologies on our Services for analytics and advertising, including 
  to help manage and display advertisements, to tailor advertisements to your interests, or to send abandoned shopping cart reminders 
  (depending on your communication preferences). The third parties and service providers use their technology to provide advertising about 
  products and services tailored to your interests which may appear either on our Services or on other websites.
</p>

<h5>Google Analytics</h5>
<p>
  We may share your information with Google Analytics to track and analyse the use of the Services. 
  The Google Analytics Advertising Features that we may use include: Google Analytics Demographics and Interests Reporting. 
  For more information on the privacy practices of Google, please visit the 
  <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer"> Google Privacy & Terms</a> page.
</p>





<h2 className="mt-5 t-5" id="ai-based-products">5. DO WE OFFER ARTIFICIAL INTELLIGENCE-BASED PRODUCTS?</h2>

<p><strong>In Short:</strong> We offer products, features, or tools powered by artificial intelligence, machine learning, or similar technologies.</p>

<p>
  As part of our Services, we offer products, features, or tools powered by artificial intelligence, machine learning, or similar technologies 
  (collectively, 'AI Products'). These tools are designed to enhance your experience and provide you with innovative solutions. 
  The terms in this Privacy Notice govern your use of the AI Products within our Services.
</p>

<h5>Our AI Products:</h5>
<p>Our AI Products are designed for the following functions:</p>
<ul>
  <li>Natural language processing</li>
  <li>AI translation</li>
  <li>AI insights</li>
</ul>

<h5>How We Process Your Data Using AI</h5>
<p>
  All personal information processed using our AI Products is handled in line with our Privacy Notice and our agreement with third parties. 
  This ensures high security and safeguards your personal information throughout the process, giving you peace of mind about your data's safety.
</p>




<h2 className="mt-5 pt-5" id="how-long-we-keep">6. HOW LONG DO WE KEEP YOUR INFORMATION?</h2>

<p><strong>In Short:</strong> We keep your information for as long as necessary to fulfil the purposes outlined in this Privacy Notice unless otherwise required by law.</p>

<p>
  We will only keep your personal information for as long as it is necessary for the purposes set out in this Privacy Notice, unless a longer 
  retention period is required or permitted by law (such as tax, accounting, or other legal requirements). No purpose in this notice will require 
  us keeping your personal information for longer than sixty (60) months past the termination of the user's account.
</p>

<p>
  When we have no ongoing legitimate business need to process your personal information, we will either delete or anonymise such information, 
  or, if this is not possible (for example, because your personal information has been stored in backup archives), then we will securely store 
  your personal information and isolate it from any further processing until deletion is possible.
</p>




<h2 className="mt-5 pt-5" id="keep-information-safe">7. HOW DO WE KEEP YOUR INFORMATION SAFE?</h2>

<p><strong>In Short:</strong> We aim to protect your personal information through a system of organisational and technical security measures.</p>

<p>
  We have implemented appropriate and reasonable technical and organisational security measures designed to protect the security of any personal 
  information we process. However, despite our safeguards and efforts to secure your information, no electronic transmission over the Internet 
  or information storage technology can be guaranteed to be 100% secure, so we cannot promise or guarantee that hackers, cybercriminals, or 
  other unauthorised third parties will not be able to defeat our security and improperly collect, access, steal, or modify your information.
</p>

<p>
  Although we will do our best to protect your personal information, transmission of personal information to and from our Services is at your 
  own risk. You should only access the Services within a secure environment.
</p>





<h2 className="mt-5 pt-5" id="your-rights">8. WHAT ARE YOUR PRIVACY RIGHTS?</h2>

<p><strong>In Short:</strong> You may review, change, or terminate your account at any time, depending on your country, province, or state of residence.</p>

<h5>Withdrawing your consent:</h5>
<p>
  If we are relying on your consent to process your personal information, which may be express and/or implied consent depending on the applicable law, 
  you have the right to withdraw your consent at any time. You can withdraw your consent at any time by contacting us by using the contact details 
  provided in the section <strong>'HOW CAN YOU CONTACT US ABOUT THIS NOTICE?' </strong>below.
</p>
<p>
  However, please note that this will not affect the lawfulness of the processing before its withdrawal nor, when applicable law allows, will it affect 
  the processing of your personal information conducted in reliance on lawful processing grounds other than consent.
</p>

<h5>Account Information:</h5>
<p>
  If you would at any time like to review or change the information in your account or terminate your account, you can:
</p>
<ul>
  <li>Contact us using the contact information provided.</li>
</ul>
<p>
  Upon your request to terminate your account, we will deactivate or delete your account and information from our active databases. However, we may retain 
  some information in our files to prevent fraud, troubleshoot problems, assist with any investigations, enforce our legal terms and/or comply with applicable 
  legal requirements. If you have questions or comments about your privacy rights, you may email us at <a href="mailto:support@ableproindia.com">support@ableproindia.com</a>.
</p>





<h2 className="mt-5 pt-5" id="do-not-track">9. CONTROLS FOR DO-NOT-TRACK FEATURES</h2>

<p>
  Most web browsers and some mobile operating systems and mobile applications include a Do-Not-Track ('DNT') feature or setting you can activate to signal your privacy preference 
  not to have data about your online browsing activities monitored and collected. 
</p>

<p>
  At this stage, no uniform technology standard for recognising and implementing DNT signals has been finalised. As such, we do not currently respond to DNT browser signals or any 
  other mechanism that automatically communicates your choice not to be tracked online. 
</p>

<p>
  If a standard for online tracking is adopted that we must follow in the future, we will inform you about that practice in a revised version of this Privacy Notice.
</p>




<h2 className="mt-5 pt-5" id="notice-update">10. DO WE MAKE UPDATES TO THIS NOTICE?</h2>

<p>
  In Short: Yes, we will update this notice as necessary to stay compliant with relevant laws.
</p>

<p>
  We may update this Privacy Notice from time to time. The updated version will be indicated by an updated 'Revised' date at the top of this Privacy Notice. If we make material 
  changes to this Privacy Notice, we may notify you either by prominently posting a notice of such changes or by directly sending you a notification. 
</p>

<p>
  We encourage you to review this Privacy Notice frequently to be informed of how we are protecting your information.
</p>




<h2 className="mt-5 pt-5" id="contact-about-notice">11. HOW CAN YOU CONTACT US ABOUT THIS NOTICE?</h2>

<p>
  If you have questions or comments about this notice, you may email us at 
  <a href="mailto:support@ableproindia.com"> support@ableproindia.com</a>.
</p>



    </div>
</section>

<Footer></Footer>
  </>
  )
}

export default Privacypolicy
